<script lang="ts">
  import { resolveContent } from "$lib/content/registry";
  import PageContainer from '$lib/components/PageContainer.svelte';
  import type { PageData } from './$types';

  let { data }: { data: PageData } = $props();

  // Use the proper dynamic content registry
  const Component = resolveContent('privacy', data.brand);
</script>

<svelte:head>
  <title>Privacy Policy - {data.config.displayName}</title>
  <meta name="description" content="Privacy policy for {data.config.displayName} services and data protection." />
  <meta property="og:title" content="Privacy Policy - {data.config.displayName}" />
  <meta property="og:type" content="website" />
</svelte:head>

<PageContainer config={data.config}>
  {#if Component}
    <svelte:component this={Component} data={data} />
  {:else}
    <div class="error-container">
      <h1>Content Not Found</h1>
      <p>The privacy policy content could not be loaded.</p>
    </div>
  {/if}
</PageContainer>
